import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomList from 'designer/component/element/List'

export const ListSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomList {...props} />
  </DragElementWrapper>
)

export const ListDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomList {...props} />
  </ElementWrapper>
)

export const listTester = rankWith(1000, scopeEndsWith('list'))
